import React from 'react';
import { getCarIcon } from 'entities/cars/utils';
import { CarAvatar } from 'shared/components';
import { useGetActiveStatus } from 'entities/cars';

interface AvatarProps {
  vehicleWeightUnladen: number;
  licensePlate: Nullable<string>;
}

export const Avatar = (props: AvatarProps) => {
  const { vehicleWeightUnladen, licensePlate } = props;
  const getActiveStatus = useGetActiveStatus();

  return (
    <CarAvatar
      kind={getCarIcon(vehicleWeightUnladen)}
      activeStatus={getActiveStatus(licensePlate)}
      avatarSize="large"
    />
  );
};
